<template>
  <div class="rent border-bottom">
    <img
      v-lazy="list.head_pic || 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1651318081,2860235060&fm=27&gp=0.jpg'"
      alt="">
    <div class="content">
      <div class="nick-name">
        <span class="text" v-html="list.nickname"></span>
        <span class="sex-icon"></span>
      </div>
      <div class="address">
        <span class="text">{{list.areas_name}}</span>
        <span class="time" v-show="list.create_time">{{list.create_time * 1000 | dateFmt(('YYYY-MM-DD HH:mm:ss'))}}</span>
        <span class="time" v-show="!list.create_time"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      // console.log(list)
    },
    props: ['list']
  }
</script>

<style lang="scss">
  .rent {
    margin: 0 10px;
    padding: 10px 0;
    img {
      width: 40px;
      height: 40px;
      margin-right: 12px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .content {
      display: inline-block;
      text-align: left;
      vertical-align: middle;
      .nick-name {
        margin-bottom: 13px;
        font-size: 14px;
      }
      .address {
        color: rgb(153, 153, 153);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/avatar.vue